<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''" >
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Berichte
                    </h3>
                </div>
                <div class="col text-right">
                    <select v-model="location.id" class="btn btn-icon btn-secondary btn-sm" :disabled="$store.getters['location/showLocationCollection'].filter(item => item.isReportAllowed).length === 0">
                        <option :value="0">Bericht erstellen</option>
                        <option v-for="location in $store.getters['location/showLocationCollection'].filter(item => item.isReportAllowed)" :key="location.id" :value="location.id">{{location.name}}</option>
                    </select>
                    <base-button size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                    <!----<base-button type="primary" size="sm" v-on:click="$router.push('/locations/create')">erstellen</base-button> --->
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>id</th>
                    <TableHeadFilter title="Status" v-model="tableOptions.filter.status" :has-filter="true" filter-type="dropdown" :dropdown-list="[{name: 'Zu genehmigen', id: 'approve'},{name: 'gespeichert', id: 'saved'},{name: 'gesendet', id: 'sent'},{name: 'in Erstellung', id: 'creation'}]" v-on:input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter v-if="isAdmin" title="Organisation" v-model="tableOptions.filter.customer" :has-filter="true" filter-type="dropdown" :dropdown-list="customers" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Standort" v-model="tableOptions.filter.location" :has-filter="true" filter-type="dropdown" :dropdown-list="locations" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Startdatum" v-model="tableOptions.dateFilter.periodStartsAt" :has-filter="true" filter-type="date" :has-sort="true" @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.periodStartsAt" @input="() => { tableOptions.sort.periodEndsAt=null; tableOptions.sort.sentAt=null; tableOptions.sort.createdAt=null; changePage(1);}"></TableSortControl> </TableHeadFilter>
                    <TableHeadFilter title="Enddatum" v-model="tableOptions.dateFilter.periodEndsAt" :has-filter="true" filter-type="date" :has-sort="true" @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.periodEndsAt" @input="() => { tableOptions.sort.periodStartsAt=null; tableOptions.sort.sentAt=null; tableOptions.sort.createdAt=null; changePage(1);}"></TableSortControl> </TableHeadFilter>
                    <TableHeadFilter title="Erstellt" v-model="tableOptions.dateFilter.createdAt" :has-filter="true" filter-type="date" :has-sort="true" @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.createdAt" @input="() => { tableOptions.sort.periodEndsAt=null; tableOptions.sort.periodStartsAt=null; tableOptions.sort.sentAt=null;  changePage(1);}"></TableSortControl> </TableHeadFilter>
                    <TableHeadFilter title="Gesendet" v-model="tableOptions.dateFilter.sentAt" :has-filter="true" filter-type="date" :has-sort="true" @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.sentAt" @input="() => { tableOptions.sort.periodEndsAt=null; tableOptions.sort.periodStartsAt=null; tableOptions.sort.createdAt=null;  changePage(1);}"></TableSortControl> </TableHeadFilter>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row" :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else><badge :type="statusColor(row.status)">{{row.status}}</badge></div>
                    </td>
                    <td v-if="isAdmin" :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.customer.name}}</div>
                    </td>
                    <td :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.location.name}}</div>
                    </td>
                    <td :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ row.periodStartsAt | formatDateToDay }}</div>
                    </td>
                    <td :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ row.periodEndsAt | formatDateToDay }}</div>
                    </td>
                    <td :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ row.createdAt | formatDate }}</div>
                    </td >
                    <td v-if="(row.sentAt !== '-0001-11-30T00:00:00+01:00')" :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ row.sentAt|formatDate }}</div>
                    </td>
                    <td v-else :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading"> </div><div v-else><span v-if="row.status === 'approve'"><b>Ihre Aktion erforderlich:<br>Bitte genehmigen und versenden</b></span>
                        <span v-else>nicht versendet</span></div>
                    </td>
                    <td class="text-right" :class="rowclass(row.status)">
                        <div v-if="isLoading" class="loading-button"> </div><div v-else><base-button :type="(row.status === 'approve') ? 'warning' : 'primary'" v-on:click="$router.push('/reports/show/'+row.id)" icon-only icon="fas fa-eye"></base-button></div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

        <ExportModal :location="location" :report-creation="reportCreation" :report="report" @reportcreated="changePage(1)"></ExportModal>
    </div>
</template>

<script>
    import TableHeadFilter from "@/components/TableHeadFilter";
    import TableSortControl from "@/components/TableSortControl";
    import ExportModal from "@/components/ExportModal";
    export default {
        name: "list",
        components:{ExportModal, TableSortControl, TableHeadFilter},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                key: 1,
                tableOptions: {
                    filter: {
                        status: null,
                        customer: null,
                        location: null,
                    },
                    dateFilter: {
                        periodStartsAt: null,
                        periodEndsAt: null,
                        createdAt:	null,
                        sentAt: null
                    },
                    sort:{
                        id: 'DESC',
                        periodStartsAt: null,
                        periodEndsAt: null,
                        createdAt:	null,
                        sentAt: null
                    }},
                tableData: [
                    {
                        id: 0,
                        customer: {
                            name: null
                        },
                        location: {
                            name: null
                        },
                        periodStartsAt: new Date(),
                        periodEndsAt: new Date(),
                        createdAt:	new Date(),
                        status: '',
                        sentAt: new Date(),
                    }
                ],
                location: {
                    id: 0
                },
                reportCreation: [],
                report: {
                    id: 0,
                    periodStartsAt: null,
                    periodEndsAt: null,
                    status: '',
                    location: null,
                    createdAt: null,
                    customer: null,
                    publicPath: '',
                },
                createdReport: {
                    id: 0,
                    periodStartsAt: null,
                    periodEndsAt: null,
                    status: '',
                    location: null,
                    createdAt: null,
                    customer: null,
                    publicPath: '',
                },
                totalitems: 0,
                page: 1,
                isLoading: false
            }
        },
        created() {
          this.changePage(this.page);
          if (!this.$store.getters['country/isReady']) this.$store.dispatch('country/getCountryCollection');
            if (!this.$store.getters['customer/isReady']) this.$store.dispatch('customer/getCustomerCollection');
            if (!this.$store.getters['location/isReady']) this.$store.dispatch('location/getLocationCollection');
        },
        watch:{
            // whenever question changes, this function will run
            // eslint-disable-next-line no-unused-vars
            reportCreation:function (newReportCreation, oldReportCreation) {
                this.key++;
            }
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            customers() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['customer/isReady']) ? [] : this.$store.getters['customer/showCustomerCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
            locations() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return (!this.$store.getters['location/isReady']) ? [] : this.$store.getters['location/showLocationCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
        },
        methods: {
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    },
                    error => {
                        this.$store.dispatch('alert/error',error);
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/reports?`+ this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter) + `page=` + page , requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            statusColor(status) {

                let colour = 'default';
                if(status === 'approve') {
                    colour= 'danger';
                } else if(status === 'sent') {
                    colour = 'success';
                }

                return colour;
            },
            rowclass(status) {
                return (status === 'approve') ? 'approve' : ''
            }

        }
    }
</script>

<style scoped>

    .approve {
        font-style: italic;
        background-color: rgba(147, 231, 195, 0.5);
    }

</style>